module.exports = __webpack_public_path__ + "static/media/30x30-10.18cb853c.png";